import { Col, Row } from "react-bootstrap";
import {
  IFullLicenceDetails,
  LicenceTypes,
} from "../../../../api/LicenceDetails";
import { ILicenceProfile } from "../../../../api/LicenceProfile";
import LatestDecisionDocument from "../../../../leap-components/LatestDecisionDocument";
import UrbanWasteWaterSiteDetails from "../../UrbanWasteWaterSiteDetails";
import ApplicationDetails from "./ApplicationDetails";
import Assessment from "./Assessment";
import KeyDates from "./KeyDates";
import SiteDetails from "./SiteDetails";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
  licenceProfile: ILicenceProfile;
}

const LicenceDetails = ({ licence, licenceProfile }: LicenceDetailsProps) => {
  const otherSiteDetails = <SiteDetails licence={licence} />;

  let siteDetails = otherSiteDetails;
  if (
    licence.siteDetails &&
    (licence.licencetype == LicenceTypes.WWDA ||
      licence.licencetype == LicenceTypes.CoA)
  ) {
    siteDetails = (
      <UrbanWasteWaterSiteDetails
        siteDetails={licenceProfile.siteDetails}
        licenceProfile={licenceProfile}
      />
    );
  }

  return (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <LatestDecisionDocument
            latestDecisionLink={licence.latestdecisionlink}
            latestDecisionType={licence.latestdecisiontype}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <ApplicationDetails licence={licence} />
        </Col>
        <Col className="col-12 col-md-6">
          <KeyDates licence={licence} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-6">
          <Assessment licence={licence} />
        </Col>
        <Col className="col-12 col-md-6">{siteDetails}</Col>
      </Row>
    </div>
  ) as JSX.Element;
};

export default LicenceDetails;
